"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findDiscountPolicyWithLowestHighestDiscount = void 0;
const findDiscountPolicyWithLowestHighestDiscount = (policies) => {
    if (policies.length === 0)
        return null;
    let lowestHighestDiscountPolicy = policies[0]; // Start with the first policy as a baseline
    let lowestHighestDiscountValue = Math.max(...policies[0].early_bird_discounts.map((discount) => discount.discount_percentage));
    policies.forEach((policy) => {
        const highestDiscountForCurrentPolicy = Math.max(...policy.early_bird_discounts.map((discount) => discount.discount_percentage));
        if (highestDiscountForCurrentPolicy < lowestHighestDiscountValue) {
            lowestHighestDiscountValue = highestDiscountForCurrentPolicy;
            lowestHighestDiscountPolicy = policy;
        }
    });
    return lowestHighestDiscountPolicy;
};
exports.findDiscountPolicyWithLowestHighestDiscount = findDiscountPolicyWithLowestHighestDiscount;
